import styled from '@emotion/styled'

import theme from '../styles/theme'
import { media, selection, lines } from '../styles/tools'

export const wrapperPadding = {
  paddingLeft: '10%',
  paddingRight: '10%',
  [media.tabletMd]: { paddingLeft: '16.666%', paddingRight: '16.666%' },
}

const Wrapper = styled.div(
  p => p.padded && wrapperPadding,
  p =>
    p.light
      ? {
          backgroundColor: theme.colors.white,
          color: theme.colors.black,
          ...lines(theme.colors.grey_100),
          ...selection(theme.colors.black, theme.colors.white),
        }
      : {
          backgroundColor: theme.colors.grey_1000,
          ...lines(),
        }
)

export default Wrapper
